import type {Lang} from 'src/transform/typings';

export const COPIED_LANG_TOKEN: Record<Lang, string> = {
    ru: 'Скопировано',
    en: 'Copied',
    ar: 'تم النسخ',
    cs: 'Zkopírováno',
    fr: 'Copié',
    es: 'Copiado',
    he: 'הועתק',
    bg: 'Копирано',
    et: 'Kopeeritud',
    el: 'Αντιγράφηκε',
    pt: 'Copiado',
    zh: '已复制',
    'zh-tw': '已複製',
    kk: 'Көшірілді',
    tr: 'Kopyalandı',
    uz: 'Nusxalandi',
};
